'use client'

import { Skeleton } from '@/components/skeleton'
import { RestaurantDetailVisualsContainer } from '@/features/restaurants/restaurant-detail/restaurant-detail-images/restaurant-detail-images-container'

export const RestaurantDetailSkeleton = () => {
    return (
        <div className="flex flex-col items-center w-full min-h-dvh">
            <RestaurantDetailVisualsContainer visuals={null} />

            <div className="mt-[-44px] md:mt-10" />

            <div className="restaurant-detail-inner-container">
                <div className="flex flex-row justify-between gap-x-20 w-full">
                    <Skeleton className="min-h-10 md:min-h-[80px] w-full md:w-[50%]" />
                    <Skeleton className="hidden md:flex min-h-[80px] w-[30%]" />
                </div>

                <div className="mt-20" />

                <Skeleton className="w-full min-h-40 md:min-h-[200px] mb-8 md:mb-14" />
                <Skeleton className="w-full min-h-40 md:min-h-[200px]" />
            </div>
        </div>
    )
}
